<template>
  <div class="logos">
    <a href="https://www.embo.org/" target="_blank">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/embo.png"
        alt="EMBO"
        title="EMBO" />
      <img v-else src="./img/embo-darkMode.png" alt="EMBO" title="EMBO" />
    </a>
  </div>
</template>

<script setup>
import {inject} from "vue";
const displayMode = inject("displayMode");
</script>

<style scoped>
.logos {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
}
img {
  height: clamp(20px, 8vw, 55px);
  width: auto;
  vertical-align: text-top;
}
</style>
